var x = Object.defineProperty;
var y = Object.getOwnPropertySymbols;
var R = Object.prototype.hasOwnProperty, P = Object.prototype.propertyIsEnumerable;
var c = (r, t, e) => t in r ? x(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, d = (r, t) => {
  for (var e in t || (t = {}))
    R.call(t, e) && c(r, e, t[e]);
  if (y)
    for (var e of y(t))
      P.call(t, e) && c(r, e, t[e]);
  return r;
};
var o = (r, t, e) => (c(r, typeof t != "symbol" ? t + "" : t, e), e);
var l = (r, t, e) => new Promise((i, a) => {
  var s = (u) => {
    try {
      h(e.next(u));
    } catch (m) {
      a(m);
    }
  }, n = (u) => {
    try {
      h(e.throw(u));
    } catch (m) {
      a(m);
    }
  }, h = (u) => u.done ? i(u.value) : Promise.resolve(u.value).then(s, n);
  h((e = e.apply(r, t)).next());
});
var f = /* @__PURE__ */ ((r) => (r.PENDING = "pending", r.RESOLVED = "resolved", r.EXPIRED = "expired", r.REJECTED = "rejected", r))(f || {});
function D(r) {
  return new Promise((t) => {
    setTimeout(() => t(void 0), r);
  });
}
class I extends Error {
  constructor(t) {
    super(t), this.name = "TimeoutError";
  }
}
function b() {
  try {
    const r = document.cookie.match(new RegExp("(^| )*vuserid=(?<vuserid>[^;]+)"));
    if (r != null && r.groups)
      return `vuid_${r.groups.vuserid}` || "";
  } catch (r) {
    console.warn("[retry-hedging](getUin)", r);
  }
  return "";
}
let g = null;
function A() {
  return typeof window == "undefined" || !window.Aegis ? null : (g || (g = new window.Aegis({
    id: "AtzxXfTTmfCpNdoSED",
    uin: b(),
    // 接口测速
    reportApiSpeed: !1,
    // 页面测速
    pagePerformance: !1,
    // 离线日志
    offlineLog: !1,
    // 静态资源测速
    reportAssetSpeed: !1,
    spa: !1,
    beforeRequest({ logType: r, logs: t }) {
      if (!(r === "log" && t.level === "2048") && !(r === "event" && t.name.includes("[retry-hedging]")))
        return !1;
    }
  })), g);
}
const E = 1e3, T = 2, v = Symbol("NO_ERROR");
function w(r) {
  return new Promise((t) => {
    const e = [];
    let i = 0;
    const a = (s, n, h, u) => {
      n === "fulfilled" && h !== void 0 ? e[s] = { status: n, value: h } : n === "rejected" && u !== void 0 && (e[s] = { status: n, reason: u }), i += 1, i === r.length && t(e);
    };
    r.forEach((s, n) => {
      s.then((h) => a(n, "fulfilled", h)).catch((h) => a(n, "rejected", void 0, h));
    }), r.length === 0 && t(e);
  });
}
var _ = Object.defineProperty, O = Object.getOwnPropertyDescriptor, L = (r, t, e, i) => {
  for (var a = i > 1 ? void 0 : i ? O(t, e) : t, s = r.length - 1, n; s >= 0; s--)
    (n = r[s]) && (a = (i ? n(t, e, a) : n(a)) || a);
  return i && a && _(t, e, a), a;
};
function N(r, t, e) {
  const i = e.value;
  return e.value = function(a) {
    return l(this, null, function* () {
      if (!this.aegis || !this.reportData)
        return i.call(this, a);
      const s = {
        status: f.PENDING,
        startTime: Date.now(),
        endTime: 0,
        duration: 0
      };
      this.reportData.promiseInfoList[a] = s;
      let n = !1;
      try {
        n = yield i.call(this, a);
      } finally {
        s.endTime = Date.now(), s.duration = s.endTime - s.startTime, n ? this.resolveIndex === a ? s.status = f.RESOLVED : s.status = f.EXPIRED : s.status = f.REJECTED;
      }
      return n;
    });
  }, e;
}
class p {
  constructor(t, e = {}) {
    /** 执行目标函数列表 */
    o(this, "targets", []);
    /** 最大尝试次数 */
    o(this, "maxAttempts", T);
    /** 对冲延迟时间 */
    o(this, "hedgingDelay", E);
    /** 超时时间 */
    o(this, "timeout", 0);
    /** 超时定时器 */
    o(this, "timer", 0);
    /** 请求 Promise */
    o(this, "promise");
    /** 子请求 Promise 队列 */
    o(this, "subPromises", []);
    /** 已尝试次数 */
    o(this, "attempts", 0);
    /** 是否已经结束逻辑 */
    o(this, "done", !1);
    /** 结果下标 */
    o(this, "resolveIndex", -1);
    /** 错误结果 */
    o(this, "errorResult", v);
    /** 上报 aegis 实例 */
    o(this, "aegis", null);
    /** 上报数据 */
    o(this, "reportData", null);
    /** 是否在请求结束后立即上报 */
    o(this, "reportImmediately", !1);
    /** 判断是否为可重试的错误（默认都可重试） */
    o(this, "isRetryableError", (t) => !0);
    /** 返回结果 */
    o(this, "succeed", () => {
    });
    /** 抛出错误 */
    o(this, "fail", () => {
    });
    this.handleParams(t, e), this.initReportData(), this.promise = this.createMainPromise();
  }
  /**
   * 执行策略
   */
  execute() {
    return l(this, null, function* () {
      return this.main(), this.setTimeoutTimer(), this.promise;
    });
  }
  /**
   * 创建全局 Promise
   */
  createMainPromise() {
    return l(this, null, function* () {
      return new Promise((t, e) => {
        this.succeed = (...i) => {
          this.done = !0, clearTimeout(this.timer), t(...i);
        }, this.fail = (...i) => {
          this.done = !0, clearTimeout(this.timer), e(...i);
        };
      }).finally(() => {
        this.afterDone();
      });
    });
  }
  /**
   * 执行对冲策略的主要逻辑
   */
  main() {
    return l(this, null, function* () {
      const t = this.executeTarget(this.attempts);
      if (this.subPromises.push(t), yield Promise.race([
        t,
        D(this.hedgingDelay)
      ]), !this.done) {
        if (this.attempts += 1, this.attempts < this.maxAttempts && this.isRetryableError(this.errorResult)) {
          this.main();
          return;
        }
        yield w(this.subPromises), this.done || this.fail(this.errorResult);
      }
    });
  }
  executeTarget(t) {
    return l(this, null, function* () {
      try {
        const e = this.targets[t % this.targets.length], i = yield e();
        return this.done || (this.resolveIndex = t, this.succeed(i)), !0;
      } catch (e) {
        return this.errorResult = e, !1;
      }
    });
  }
  /**
   * 设置超时定时限制
   */
  setTimeoutTimer() {
    this.timeout && (this.timer = setTimeout(() => {
      if (this.hasErrorResult()) {
        this.fail(this.errorResult);
        return;
      }
      this.fail(new I(`timeout of ${this.timeout}ms exceeded`));
    }, this.timeout));
  }
  /**
   * 处理策略配置选项，检查参数合法性
   */
  handleParams(t, e) {
    var i, a, s;
    if (this.targets = Array.isArray(t) ? t : [t], this.targets.some((n) => typeof n != "function"))
      throw new TypeError("hedging target must be a function or an array of function");
    if (this.maxAttempts = typeof e.maxAttempts == "number" ? e.maxAttempts : Math.max(this.targets.length, T), this.hedgingDelay = (i = e.hedgingDelay) != null ? i : E, this.timeout = (a = e.timeout) != null ? a : 0, e.retryableError !== void 0 && (this.isRetryableError = (n) => this.hasErrorResult() ? typeof e.retryableError == "function" ? e.retryableError(n) : !!e.retryableError : !0), e.report !== !1)
      try {
        this.aegis = e.aegis || A();
      } catch (n) {
        console.warn("[retry-hedging](handleParams) aegis init failed", n);
      }
    this.reportImmediately = (s = e.reportImmediately) != null ? s : !1;
  }
  /**
   * 是否存在错误结果
   */
  hasErrorResult() {
    return this.errorResult !== v;
  }
  /**
   * 请求结束之后的处理
   */
  afterDone() {
    return l(this, null, function* () {
      if (!(!this.aegis || !this.reportData)) {
        if (this.reportData.endTime = Date.now(), this.reportData.duration = this.reportData.endTime - this.reportData.startTime, this.reportData.resolveIndex = this.resolveIndex, yield D(0), this.reportImmediately) {
          this.report();
          return;
        }
        w(this.subPromises).then(() => this.report());
      }
    });
  }
  /**
   * 上报数据结构初始化
   */
  initReportData() {
    this.aegis && (this.reportData = {
      resolveIndex: -1,
      duration: 0,
      startTime: Date.now(),
      endTime: 0,
      targetsLength: this.targets.length,
      maxAttempts: this.maxAttempts,
      hedgingDelay: this.hedgingDelay,
      promiseInfoList: [],
      version: "1.1.12"
    });
  }
  /**
   * 上报数据
   */
  report() {
    var a, s;
    if (!this.reportData || !this.aegis)
      return;
    this.aegis.report(this.reportData);
    const t = ((s = (a = this.reportData.promiseInfoList) == null ? void 0 : a[0]) == null ? void 0 : s.status) !== "rejected", e = t ? "成功" : "失败", i = this.reportData.resolveIndex !== -1 ? "成功" : "失败";
    this.aegis.reportEvent({
      name: "[retry-hedging] 请求情况",
      ext1: `原始请求${e}`,
      ext2: `总体请求${i}`
    }), t || this.aegis.reportEvent({
      name: "[retry-hedging] 对冲兜底情况",
      ext1: i
    });
  }
}
L([
  N
], p.prototype, "executeTarget", 1);
function j(r = {}) {
  return function(t, e = {}) {
    const i = d(d({}, r), e);
    return new p(t, i).execute();
  };
}
function M(r, t = {}) {
  return new p(r, t).execute();
}
export {
  I as TimeoutError,
  M as hedging,
  j as useHedging
};
